import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "@/index.css"
import { Providers } from "@/app/providers"
import { initSentry } from "@/lib/sentry"

initSentry()

const container = document.getElementById("root")

if (!container) {
  throw new Error("Root element not found")
}

createRoot(container).render(
  <StrictMode>
    <Providers />
  </StrictMode>
)
